module.exports = __webpack_public_path__ + "static/media/MissedThreat.c0755937.svg";